import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IStampsOfferViewRatingHistory } from '@/shared/model/stamps-offer-view-rating-history.model';

const baseApiUrl = 'api/stamps-offer-view-rating-histories';
const baseSearchApiUrl = 'api/_search/stamps-offer-view-rating-histories?query=';

export default class StampsOfferViewRatingHistoryService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IStampsOfferViewRatingHistory> {
    return new Promise<IStampsOfferViewRatingHistory>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IStampsOfferViewRatingHistory): Promise<IStampsOfferViewRatingHistory> {
    return new Promise<IStampsOfferViewRatingHistory>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IStampsOfferViewRatingHistory): Promise<IStampsOfferViewRatingHistory> {
    return new Promise<IStampsOfferViewRatingHistory>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
